import React from 'react'
import Forms from '../../../components/common/Form'
import formConfig from "../../../formJsonData/Purchase/AMCMaster/AMCList.json";
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json";
const AMCList = () => {
  return (
    <div>
      
      <Forms formConfig={formConfig} searchConfigJson={searchConfigJson.amc}/>
    </div>
  )
}

export default AMCList